<div class="xf-content-height">
    <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
        <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
            <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                <div class="parsys aem-GridColumn aem-GridColumn--default--12">
                    <div class="richtext parbase section"><p>
                        <h1 style="text-align: center;"><span class="rte-font-size-24 terms-heading">{{properties.partnersBanners.termsAndCondition}}</span>
                        </h1>
                    </div>
                    <div class="terms-content" [innerHTML]="termsContent">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
